import styled from 'styled-components';

import CheckboxInputInput from './CheckboxInputInput';
import ToolIcon from 'components/Icons/ToolIcon';

export default styled(ToolIcon)`
  position: absolute;
  top: 0;
  left: 0;
  vertical-align: middle;
  height: 2rem;
  width: 2rem;
  pointer-events: none;

  svg {
    height: 1.5rem;
    width: 1.5rem;
    margin: 0.25rem;
  }

  path {
    stroke: rgba(111, 88, 255, 1);
  }

  ${CheckboxInputInput} ~ & {
    display: none;
  }

  ${CheckboxInputInput}:checked ~ & {
    display: inherit;
  }
`;
